const NUM_STRIPES = 8;
const SW = 11, SH = 17, R = 47;

export default function CasinoChip({ value, color, stripe, size = 60, selected = false }) {
  const id = `cc-${String(value).replace('.', '_')}`;

  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={`casino-chip${selected ? ' casino-chip--selected' : ''}`}
    >
      <defs>
        <clipPath id={id}>
          <circle cx="50" cy="50" r={R} />
        </clipPath>
        <radialGradient id={`${id}-g`} cx="38%" cy="34%" r="62%">
          <stop offset="0%"   stopColor="#FFFFFF" stopOpacity="0.25" />
          <stop offset="55%"  stopColor={color}   stopOpacity="1" />
          <stop offset="100%" stopColor="#000000" stopOpacity="0.35" />
        </radialGradient>
      </defs>

      <circle cx="50" cy="50" r={R} fill={color} />
      <circle cx="50" cy="50" r={R} fill={`url(#${id}-g)`} />

      <g clipPath={`url(#${id})`}>
        {Array.from({ length: NUM_STRIPES }, (_, i) => (
          <rect
            key={i}
            x={50 - SW / 2}
            y={50 - R}
            width={SW}
            height={SH}
            rx="2"
            fill={stripe}
            opacity="0.88"
            transform={`rotate(${(i * 360) / NUM_STRIPES} 50 50)`}
          />
        ))}
      </g>

      <circle cx="50" cy="50" r={R - 1}        fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="1.8" />
      <circle cx="50" cy="50" r={R - SH + 1}   fill="none" stroke="rgba(255,255,255,0.40)" strokeWidth="1.5" />
      <circle cx="50" cy="50" r={R - SH - 2}   fill={color} />
      <circle cx="50" cy="50" r={R - SH - 2}   fill={`url(#${id}-g)`} opacity="0.6" />
      <circle cx="50" cy="50" r={R - SH - 3}   fill="none" stroke="rgba(255,255,255,0.45)" strokeWidth="1.5" />

      <ellipse cx="37" cy="34" rx="11" ry="7" fill="rgba(255,255,255,0.28)" transform="rotate(-35 37 34)" />

      <text
        x="50" y="51"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="white"
        fontWeight="900"
        fontSize={value >= 10 ? 20 : 22}
        fontFamily="'Arial Black',Arial,sans-serif"
        stroke="rgba(0,0,0,0.55)"
        strokeWidth="0.8"
        paintOrder="stroke"
      >
        {value}
      </text>
    </svg>
  );
}
